<mat-card class="news-card">
    <mat-card-header mat-dialog-title>
        <mat-card-title class="text-uppercase text-left model-header news-modal-header"
                        *ngIf="!passedData.data.isNew">Edit Article
        </mat-card-title>
        <mat-card-title class="text-uppercase text-left model-header news-modal-header"
                        *ngIf="passedData.data.isNew">Add Article
        </mat-card-title>
        <div class="dialog-close">
            <button mat-button matSuffix mat-icon-button mat-dialog-close>
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </mat-card-header>
</mat-card>
<mat-card-content>
    <form [formGroup]="newsForm">
        <div class="w-100 addNewsForm">
            <mat-form-field class="w-100">
                <mat-label>Title:</mat-label>
                <input matInput type="text" id="title" class="form-control" formControlName="title" cdkfocusinitial>
            </mat-form-field>
            <p>Description:</p>
            <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="description" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor
                        [editor]="description"
                        [disabled]="false"
                        [placeholder]="'Type here...'"
                        formControlName="description" id="description"
                        outputFormat="html"
                ></ngx-editor>
            </div>
            <br>
            <p>Details:</p>
            <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="details" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor
                        [editor]="details"
                        [disabled]="false"
                        [placeholder]="'Type here...'"
                        formControlName="details" id="details"
                        outputFormat="html"
                ></ngx-editor>
            </div>
        </div>
    </form>
    <div class="col text-right">
        <button class="submit" mat-raised-button [color]="'primary'" (click)="onSubmit()" mat-dialog-close>Save</button>
        <button mat-raised-button mat-dialog-close>Cancel</button>
    </div>

</mat-card-content>

